<template>
  <div class="row">
    <div class="col-12">
      <loading-card v-if="isLoading" />
      <eula v-else-if="!acceptedEula" />
      <card v-else title="Downloads">
        <div class="frame" v-if="!products || products.length <= 0">
          <div class="table-active row recursive-row">
            <div class="col-12 text-center">
              <p>No downloads were found.</p>
            </div>
          </div>
        </div>
        <div v-else>
          <product-versions-row v-for="product in products"
            :key="product.id"
            :product="product" />
        </div>
      </card>
    </div>
    <version-modal @hasUpdate="fetchProducts" />
    <product-modal @hasUpdate="fetchProducts" />
    <download-modal @hasUpdate="fetchProducts" />
  </div>
</template>

<script>
import ProductVersionsRow from '../components/Tables/ProductVersionsRow';
import ProductModal from '../components/Modals/ProductModal';
import VersionModal from '../components/Modals/VersionModal';
import DownloadModal from '../components/Modals/DownloadModal';
import LoadingCard from '../components/Cards/LoadingCard';
import Card from '../components/Cards/Card';
import Eula from '../components/Eula';
import { mapGetters } from 'vuex';

export default {
  name: "Downloads",
  components: {
    ProductVersionsRow,
    ProductModal,
    VersionModal,
    DownloadModal,
    LoadingCard,
    Card,
    Eula
  },
  data() {
    return {
      isLoading: false
    };
  },
  async created() {
    if (!this.acceptedEula) {
      this.isLoading = true;
      await this.$store.cache.dispatch('user/fetchMe');
      await this.$store.dispatch('organization/checkEula');
    }
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      this.isLoading = true;
      await this.$store.dispatch('product/fetchProducts');
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters('product', ['products']),
    ...mapGetters('organization', ['acceptedEula']),
    ...mapGetters('user', ['user'])
  }
};
</script>
